/**
 * Counts the number of active filters in a record
 */
const countFiltersHelper = (fields: Record<string, any>): number => {
  return Object.keys(fields).filter(key => {
    if (typeof fields[key] === "string") {
      return fields[key].length > 0;
    }
    if (Array.isArray(fields[key])) {
      return fields[key].length > 0;
    }
    if (typeof fields[key] === "boolean") {
      return fields[key];
    }
    return false;
  }).length;
};

export default countFiltersHelper;
